<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
    <div class="card">
        <div class="card-body">
            @if (contactType == 'cpiVendor') {
            <form [formGroup]="cpiInformation">
                <div class="form-row">
                    <div class="form-group col">
                        <label for="defaultDeductible">Default Deductible</label>
                        <div class="input-group flex-nowrap">
                            <currency-input [control]="this.cpiInformation.get('defaultDeductible')"></currency-input>
                        </div>
                    </div>
                    <div class="form-group col">
                        <label for="defaultPremium">Default Premium</label>
                        <div class="input-group flex-nowrap">
                            <currency-input [control]="this.cpiInformation.get('defaultPremium')"></currency-input>
                        </div>
                    </div>
                    <div class="form-group col">
                        <label for="policyNumber">Policy Number</label>
                        <input class="form-control" type="text" id="policyNumber" formControlName="policyNumber" autocomplete="off">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="primary" formControlName="primary">
                            <label class="custom-control-label" for="primary">Mark as Primary CPI Insurance</label>
                        </div>
                    </div>
                </div>
            </form>
            }
            <div class="card-footer">
                <button class="btn btn-sm btn-primary" (click)="saveCPI()" id="save-cpi-button" [disabled]="!cpiInformation.valid || contactId == 0">Save</button>
            </div>
        </div>
    </div>
    @if (calledFrom == null) {
    <div class="text-right">
        <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
    </div>
    }
</div>
